import { Tooltip } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import { IResultadoItem } from "../../../model";
import { AppStore } from "../../../stores/AppStore";
import { ResultadoStore } from "../../../stores/resultados/ResultadoStore";
import { NotaItemDialog } from "./item-detail/ItemDialogNota";
import { columns, columns_notas_retroativas } from "../../utils/TableDetalhamento"
import BootstrapTable from 'react-bootstrap-table-next';
import { AppIcon } from "../../utils/AppIcon";

const numeral = require("numeral");

interface Props {
  items: IResultadoItem[];
  modelo: string;
  entrada_saida: string
  data: any;
}

@observer
export class DetalhamentoNfeTable extends React.Component<Props, {}> {

  obs = observable({
    new_columns: columns,
    new_columns_retro: columns_notas_retroativas,
    viewing: null as IResultadoItem
  })

  constructor(props) {
    super(props);
  }

  componentDidMount() {

    let temp_table: any[] = [];

    temp_table.push({
      dataField: 'info',
      text: 'Ações',
      formatter: (cell, row) => {
        return this.buttonFormatterDetalhes(cell, row);
      },
      headerAlign: 'center',
      align: 'center'
    },{
      dataField: 'class',
      text: 'Classificação',
      formatter: (cell, row) => {
        return this.formatterClassificacao(cell, row);
      },
      headerAlign: 'center',
      align: 'center'
    });

    this.obs.new_columns = columns.concat(temp_table)
    this.obs.new_columns_retro = columns_notas_retroativas.concat(temp_table)
  }

  handleContest(item: IResultadoItem) {
    AppStore.setContestarItem(item);
  }

  handleView(item: IResultadoItem) {
    this.obs.viewing = item;
  }

  handleViewClose = async () => {
    this.obs.viewing = null;
  };

  onSelectAll = async (isSelect, rows) => {

    if (isSelect) {

      let data = rows?.map(value => {
        return {
          id: value.id,
          data: value.data
        }
      })

      ResultadoStore.setContestarItemsList(data);

    } else {

      ResultadoStore.resetContestarItems();

    }

  };

  onSelect = async (item, checked) => {

    let data = {
      id: item.id,
      data: item.data
    }

    if (checked) {

      ResultadoStore.setContestarItems(data);

    } else {

      ResultadoStore.deleteByIdContestarItems(item.id);

    }
  }

  renderViewDialog() {
    return (
      <NotaItemDialog
        modelo={this.props.modelo}
        item={this.obs.viewing}
        entrada_saida={this.props.entrada_saida}
        data={this.props.data}
        onClose={this.handleViewClose}
      />
    );
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  handleTrClassFormat(row, rowIndex) {
    let classNameTr = "";

    let valorIcmsAnt = row.any_item.valor_icms_ant;

    let classificacaoId = row.any_item.classificacao_id;
    let nomeClassificacao = row.any_item.classificacao_nome;

    if (row.any_item.devolucao) {
      classNameTr = "item-sem-icms-st";
    }

    if (classificacaoId) {
      if (
        nomeClassificacao == "Substituição Tributária" && valorIcmsAnt == 0 &&
        row.any_item.ncm != "27101921" && row.any_item.ncm != "84133010" &&
        row.any_item.ncm != "31021010" && row.any_item.ncm != "27101259" &&
        row.any_item.uf_origem != "PA"
      ) {
        classNameTr = "item-sem-icms-st";
      }
    } else {
      if (
        row.any_item.ncm != "27101921" && row.any_item.ncm != "84133010" &&
        row.any_item.ncm != "31021010" && row.any_item.ncm != "27101259" &&
        row.any_item.uf_origem != "PA"
      ) {
        classNameTr = "item-sem-icms-st";
      }
    }

    return classNameTr;
  }

  formatterClassificacao = (cell, row) => {

    return (<>

      {row.classificacao_cliente_final == "REVENDA" ? <Tooltip content={"Mercadoria para Revenda"}><AppIcon name="currency_exchange" color="#1F77B4" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "USO E CONSUMO" ? <Tooltip content={"Material de Uso e Consumo"}><AppIcon name="work" color="#2CA02C" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "ATIVO IMOBILIZADO" ? <Tooltip content={"Ativo Imobilizado"}><AppIcon name="barcode" color="#D62728" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "TRANSFERÊNCIA" ? <Tooltip content={"Transferência de Mercadoria"}><AppIcon name="swap_horiz" color="#9467BD" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "CONSERTO" ? <Tooltip content={"Retorno Remessa para Conserto"}><AppIcon name="build" color="#FF7F0E" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "COMODATO" ? <Tooltip content={"Remessa em Comodato"}><AppIcon name="handshake" color="#E377C2" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "COMBUSTÍVEL USO" ? <Tooltip content={"Compra de Combustível pra uso e Consumo"}><AppIcon name="local_gas_station" color="#BCBD22" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "COMBUSTÍVEL REVENDA" ? <Tooltip content={"Compra de Combustível pra Revenda"}><AppIcon name="sell" color="#0F766E" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "SERVIÇO" ? <Tooltip content={"Compra para utilização na prestação do Serviço"}><AppIcon name="engineering" color="#17BECF" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "INDUSTRIALIZAÇÃO" ? <Tooltip content={"Insumos pra industrialização"}><AppIcon name="precision_manufacturing" color="#8C564B" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "ESTOQUE" ? <Tooltip content={"Baixa de Estoque"}><AppIcon name="remove_shopping_cart" color="#4d4d4d" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "BONIFICAÇÃO" ? <Tooltip content={"Bonificação"}><AppIcon name="redeem" color="#00A6FB" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "MERCADORIA" ? <Tooltip content={"Retorno de Mercadoria"}><AppIcon name="assignment_return" color="#3A0CA3" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "GARANTIA" ? <Tooltip content={"Remessa em Garantia"}><AppIcon name="verified" color="#00B894" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "FUTURA" ? <Tooltip content={"Remessa para entrega Futura"}><AppIcon name="schedule" color="#c78e06" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "DEVOLUÇÃO" ? <Tooltip content={"Devolução de Venda"}><AppIcon name="undo" color="#C1121F" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "OUTRAS ENTRADAS" ? <Tooltip content={"Outras entradas não especificadas"}><AppIcon name="more_horiz" color="#475569" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "DEMONSTRAÇÃO" ? <Tooltip content={"Entrada de Mercadoria para Demonstração"}><AppIcon name="visibility" color="#7C3AED" size={22}/></Tooltip>
        :row.classificacao_cliente_final == "CONSIGNAÇÃO" ? <Tooltip content={"Entrada de Mercadoria em Consignação"}><AppIcon name="inventory_2" color="#B45309" size={22}/></Tooltip>
        : <></>
      }

    </>)

  };

  buttonFormatterDetalhes = (cell, row) => {

    if (AppStore.obs1.usuario) {

      if (ResultadoStore.obs.itens_processando.indexOf(row.id) != -1) {

        return (<>
          <img src="/images/contestar.svg" width={20} style={{cursor: "pointer"}} onClick={() => this.handleView(row.any_item)}/>
          &nbsp;&nbsp;&nbsp;
          <img src="/images/icone-relogio.png" width={23} />
        </>)

      }

      return (<div style={{display: "flex", justifyContent: "center"}}>

        <Tooltip><img src="/images/contestar.svg" width={20} style={{cursor: "pointer"}} onClick={() => this.handleView(row.any_item)}/></Tooltip>
        &nbsp;&nbsp;&nbsp;
        {row.any_item.contestacao_calc_id
          ? <Tooltip content={"Contestado"}><img src="/images/contestado.png" width={20} style={{cursor: "pointer"}} onClick={() => this.handleContest(row.any_item)}/></Tooltip>
          : <Tooltip content={"Contestar"}><img src="/images/contestar.png" width={20} style={{cursor: "pointer"}} onClick={() => this.handleContest(row.any_item)}/></Tooltip>
        }

      </div>);

    }

  };

  public render() {
    // let unselectable: string[] = [];

    const items_new = this.props.items?.map((item: IResultadoItem) => {
      let valorPagar = (parseFloat(item.valor_icms_ant) || 0) - (parseFloat(item.valor_contestacao_icms) || 0);
      let valorIcmsAnt = parseFloat(item.valor_icms_ant) || 0;

      // if (item.chave_nota.slice(0, 2) == "15" && this.props.modelo == "NF-E" && item.entrada_saida == "entrada") {
      //   unselectable.push(item.id);
      // }

      return (
        {
          id: item.id,
          any_item: item,
          dhrecbto: item.dhrecbto,
          serie_nota: item.serie_nota + " / " + (item.num_nota ? item.num_nota : "") + " - " + item.num_item,
          data: item.data,
          data_calculo: item.data_calculo,
          ncm: <p>{item.ncm}/ <br /> {(item.cest ? item.cest : "Sem CEST")}</p>,
          descricao: item.descricao.substring(0, 40).toUpperCase(),
          valor_produto: item.devolucao ? `${numeral(parseFloat(item.valor_produto)).format("$ 0,0.00")} (DEVOLUÇÃO)` : numeral(parseFloat(item.valor_produto)).format("$ 0,0.00"),
          classificacao_nome: (item.classificacao_nome && item.classificacao_nome.startsWith("1"))
            ? item.classificacao_nome.substring(0, 4)
            : "Sem",
          valor_icms_ant: numeral(valorIcmsAnt).format("$ 0,0.00"),
          valor_contestado_icms: numeral((parseFloat(item.valor_contestacao_icms) || 0)).format("$ 0,0.00"),
          valor_pagar: numeral(valorPagar).format("$ 0,0.00"),
          info: item,
          contestar: item,
          chave_nota: item.chave_nota,
          cfop: item.cfop,
          pis_cofins: (item.pis ? item.pis : "") + " / " + (item.cofins ? item.cofins : ""),
          cst: item.cst,
          classificacao_cliente_final: item.classificacao_cliente_final,
          aliq_icms: (parseFloat(item.aliq_icms) || 0).toFixed(2) + "%"
        }
      );
    });

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: false,
      style: { backgroundColor: '#e9f6ff' },
      onSelectAll: this.onSelectAll,
      selected: ResultadoStore.obs.contestarItems?.map(value => value.id),
      onSelect: this.onSelect,
      nonSelectable: ResultadoStore.obs.itens_processando,
    };

    return (
      <>
        <div>
          {ResultadoStore.obs.notasDivergentes ?
            <>
              {/* @ts-ignore */}
              <BootstrapTable keyField="id" className="TableDefault" data={items_new} columns={this.obs.new_columns_retro} selectRow={selectRowProp} rowClasses={this.handleTrClassFormat} hover />
            </>
            :
            <>
              {/* @ts-ignore */}
              <BootstrapTable keyField="id" className="TableDefault" data={items_new} columns={this.obs.new_columns} selectRow={selectRowProp} rowClasses={this.handleTrClassFormat} hover />
            </>
          }
        </div>

        {this.obs.viewing && this.renderViewDialog()}
      </>
    );
  }
}

export default DetalhamentoNfeTable;
